/* assets/xmas-countdown.js — <xmas-countdown> (Weihnachten 2026)
 * Zählt volle Kalendertage bis zum Beginn des Zieltages (00:00 lokale Zeit des Besuchers),
 * aufgerundet, Minimum 0. Ist der Zieltag erreicht und data-hide-done gesetzt, wird das
 * Element ausgeblendet. Mehrfach-instanzfähig; Custom Elements initialisieren sich auch nach
 * shopify:section:load von selbst und räumen bei disconnect auf.
 */
(function () {
  'use strict';
  if (!('customElements' in window) || customElements.get('xmas-countdown')) return;

  var DAY_MS = 86400000;

  function parseTarget(value) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value || '').trim());
    if (!m) return null;
    // Beginn des Zieltages in lokaler Zeit
    return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]), 0, 0, 0, 0);
  }

  function daysUntil(target) {
    var diff = target.getTime() - Date.now();
    return Math.max(0, Math.ceil(diff / DAY_MS));
  }

  function render(el, template, days) {
    var textEl = el.querySelector('[data-xmas-countdown-text]');
    if (!textEl) return;
    var parts = String(template).split('[days]');
    textEl.textContent = '';
    parts.forEach(function (part, i) {
      textEl.appendChild(document.createTextNode(part));
      if (i < parts.length - 1) {
        var num = document.createElement('span');
        num.className = 'xmas-countdown__days';
        num.setAttribute('data-xmas-countdown-days', '');
        num.textContent = String(days);
        textEl.appendChild(num);
      }
    });
  }

  class XmasCountdown extends HTMLElement {
    connectedCallback() {
      this._target = parseTarget(this.dataset.target);
      if (!this._target) return;
      this._tick = this._tick.bind(this);
      this._tick();
      this._timer = window.setInterval(this._tick, 60000);
    }

    disconnectedCallback() {
      if (this._timer) window.clearInterval(this._timer);
      this._timer = null;
    }

    _tick() {
      var days = daysUntil(this._target);
      var hideDone = this.hasAttribute('data-hide-done');
      if (days === 0 && hideDone) {
        this.hidden = true;
        return;
      }
      this.hidden = false;
      var template = days === 1 && this.dataset.templateOne ? this.dataset.templateOne : (this.dataset.template || '[days]');
      var current = this.querySelector('[data-xmas-countdown-days]');
      if (current && this._lastDays === days) return; // nichts geändert
      this._lastDays = days;
      render(this, template, days);
    }
  }

  customElements.define('xmas-countdown', XmasCountdown);
})();
